import name from './name'

const selectSliceData = state => state[name]

const campaignData = state => selectSliceData(state).campaign

export { campaignData }
